// extracted by mini-css-extract-plugin
export default {"previewButton":"azQ2c","buttons":"COM2k","graphContainer":"NTf0a","collectedAmount":"w_gOX","collectedText":"y2HcB","noVisitedStyle":"zQvPg"};